import { Meeting } from "../models/meetings.model";
import { responseHero } from "../utils/axiosInterceptor";

export const fetchMeetings = (): Promise<Meeting[]> => {
    return new Promise<Meeting[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/meetings/active`).then((response) => {
            resolve(response.data as Meeting[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};